import { useContext } from "react";
import { rankingContext } from "../contexts/ranking";

export const useRanking = () => {
  const context = useContext(rankingContext);
  if (!context) {
    throw new Error("useRanking must be used within a RankingProvider");
  }
  return context;
};
